import { documentAction } from "../actionTypes"

const initialState = {
  documentList: {},
  loader: false,
  uploading: false,
  progress: 0,
}

export default function document(state = initialState, { type, payload }) {
  switch (type) {
    case documentAction.DOCUMENT_LIST_INITIATE:
      return { ...state, loader: true }
    case documentAction.DOCUMENT_LIST_SUCCESS:
      return { ...state, loader: false, documentList: payload.data }
    case documentAction.DOCUMENT_LIST_FAILURE:
      return { ...state, loader: false }

    case documentAction.DOCUMENT_UPLOAD_INITIATE:
      return { ...state, uploading: true, progress: 0 }
    case documentAction.DOCUMENT_UPLOAD_PROGRESS:
      return { ...state, progress: payload }
    case documentAction.DOCUMENT_UPLOAD_SUCCESS:
    case documentAction.DOCUMENT_UPLOAD_FAILURE:
      return { ...state, uploading: false, progress: 0 }
    default:
      return state
  }
}
